import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: 'p-accordion'
})
export class PatchAccordionInputsDirective implements AfterViewInit {
  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    const inputs = this.el.nativeElement.querySelectorAll('input');
    inputs.forEach((input: HTMLInputElement) => {
      input.addEventListener('keydown', (e: KeyboardEvent) => {
        if (['Home', 'End'].includes(e.key)) {
          e.stopImmediatePropagation();
        }
      });
    });
  }
}
